import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

import { FaqCategory } from "@/components/General/Faq/types/faqCategory.types";
import { FaqQuestion } from "@/components/General/Faq/types/faqQuestion.types";
import { FaqSelection } from "@/components/General/Faq/types/faqSelection.types";

type FaqContextValue = {
    categories: Array<FaqCategory>;
    selection: FaqSelection;
    onSelectCategory: (category: FaqCategory) => void;
    onToggleQuestion: (question: FaqQuestion) => void;
};

type FaqContextProviderProps = {
    categories: Array<FaqCategory>;
    selection: FaqSelection;
    onSelectCategory: (category: FaqCategory) => void;
    onToggleQuestion: (question: FaqQuestion) => void;
    children: ReactNode;
};

export const FaqContext = createContext<FaqContextValue | undefined>(undefined);
FaqContext.displayName = "FaqContext";

export const FaqContextProvider = ({
    categories,
    selection,
    onSelectCategory,
    onToggleQuestion,
    children
}: FaqContextProviderProps) => {
    return (
        <FaqContext
            value={{
                categories,
                selection,
                onSelectCategory,
                onToggleQuestion
            }}
        >
            {children}
        </FaqContext>
    );
};

export const useFaqContext = () => {
    const context = use<FaqContextValue | undefined>(FaqContext);

    if (!isDefined(context)) {
        throw new Error(`${FaqContext.displayName} is undefined.`);
    }

    return context;
};
